// src/pages/AuthLanding.jsx
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useUser } from "../context/UserContext";
import { fetchUserSummary } from "../api/accountApi";

export default function AuthLanding() {
  const { user, booted } = useUser();
  const nav = useNavigate();
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    if (!booted) return;

    let mounted = true;
    (async () => {
      const hasIdentity = !!(user?.id || user?.phoneNumber || user?.email);
      if (!hasIdentity) {
        nav("/", { replace: true });
        return;
      }

      try {
        const summary = await fetchUserSummary({
          id: user?.id ?? null,
          phoneNumber: user?.phoneNumber ?? null,
          email: user?.email ?? null,
        });
        if (!mounted) return;
        if (summary?.hasActivity) nav("/user-dashboard", { replace: true, state: { summary } });
        else nav("/discover", { replace: true });
      } catch {
        nav("/discover", { replace: true });
      } finally {
        mounted && setChecking(false);
      }
    })();

    return () => {
      mounted = false;
    };
  }, [booted, user?.id, user?.phoneNumber, user?.email, nav]);

  return checking ? null : null;
}
